import Backbone from 'backbone';
import EventHub from '~/eventHub';

function UtilsService() { }
UtilsService.prototype = {
	counter: 0,
	IMAGE_EXT: [
		"jpg", "jpeg", "jfif", "pjpeg", "pjp", "apng", "avif", "gif", "png", "svg", "webp"
	],
	AUDIO_EXT: [
		"3gp", "aac", "flac", "mpg", "mpeg", "mp3", "mp4", "m4a", "oga", "ogg", "wav", "webm"
	],
	VIDEO_EXT: [
		"3gp", "mpg", "mpeg", "mp4", "m4v", "m4p", "mov", "ogv", "ogg", "webm"
	],
	//otras extensiones soportadas
	OTHER_EXT: [

	],
	initialize: function () {

	},

	/**
	* sets date format to latn
	* @function fixDateFormat
	* @param date
	* @returns [date string format]
	* @memberOf UtilsService.prototype
	*/
	fixDateFormat: function (date) {
		/**
		* @member [string] format
		*/
		var format = '';
		/**
		* @member [year: string, month: string, day: string] options
		*/
		var options = {year: 'numeric', month: 'numeric', day: 'numeric'};
		//set format
		if (date.toLocaleDateString) {
			format = date.toLocaleDateString("latn", options);
		}
		else {
			format = (new Date(date)).toLocaleDateString("latn", options);
		}
		return format;
	},

	waitFor: function(object,param){
		var result = new Promise(function(resolve, reject) {
			if(!(param in object)){
				var check = function () {
					if(!(param in object)){
						setTimeout(check, 10);
					}
					else {
						resolve("");
					}
				};
				check();
			}
			else {
				resolve("");
			}
		});
		return result;
	},

	getprofilepermissions: function(){
		var permissions = JSON.parse(localStorage.getItem('permissions'));
		return permissions;
	},

	getFileType: function(value){
		var type;
		if(this.IMAGE_EXT.includes(value)){
			type = 'image';
		}
		if(this.AUDIO_EXT.includes(value)){
			type = 'audio';
		}
		if(this.VIDEO_EXT.includes(value)){
			type = 'video';
		}
		if(this.OTHER_EXT.includes(value)){
			type = 'other';
		}
		return type;
	},

	handleInvalidSession: function(){
		var userID = Parse.User.current().id;
		if(localStorage.getItem("pushInfo") != '' && localStorage.getItem("pushInfo") != null)
		{
			var pushInfo = JSON.parse(localStorage.getItem("pushInfo"));
			var params = { pushInfo, userID };
			Parse.Cloud.run("unsuscribeWebPushUser", params);
		}
		Parse.User._clearCache();
		window.localStorage.clear();
		EventHub.trigger('logout');
		Backbone.history.loadUrl('/login?reset');
	}
}
/**
 * Module UtilsService, helps to exports a UtilsService object
 * @module services/utilsService
 * @returns [date string format]
 */
export default new UtilsService();
